/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_L4Inputs */

const en_mk_sec_pg_l4 = /** @type {(inputs: Mk_Sec_Pg_L4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A full transcript of every agent run`)
};

const id_mk_sec_pg_l4 = /** @type {(inputs: Mk_Sec_Pg_L4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkrip penuh setiap kerja agen`)
};

/**
* | output |
* | --- |
* | "A full transcript of every agent run" |
*
* @param {Mk_Sec_Pg_L4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_l4 = /** @type {((inputs?: Mk_Sec_Pg_L4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_L4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_l4(inputs)
	return en_mk_sec_pg_l4(inputs)
});